"use strict";

($dt => {
	
	const controller = {

		instances: [],
		
		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {
			const form_container = container.querySelector('form[data-form-key="membershipstatus"]');
			controller.instances.push({
				form_elem: form_container,
				on_success: resp => {
					// Hide inputs
					container.querySelector('.membership-input').classList.add('hidden');

					// Build Results Info
					const success_container = container.querySelector('.membership-result');

					// Membership Level
					const member_meta = document.createElement('div');
					member_meta.classList.add('membership-meta');
					member_meta.innerHTML = 
						`
							<p><b>Membership Level:</b> ${resp.dev_attachment.membership_level}</p>
						`;

					// Member List
					const member_list = document.createElement('div');
					member_list.classList.add('membership-list');
					const html_table = document.createElement('table');

					// Table Header
					const header = document.createElement('thead');
					header.innerHTML = 
						`
							<tr>
								<th>Membership ID</th>
								<th>Member</th>
								<th>Date Opened</th>
								<th>Valid Until</th>
								<th>Age Group</th>
								<th>Record Type</th>
							</tr>
						`;
					html_table.appendChild(header);

					// Member Rows
					const body = document.createElement('tbody');
					resp.dev_attachment.members.forEach(mem => {
						const row = document.createElement('tr');
						row.innerHTML = 
							`
								<td>${mem.membership_id}</td>
								<td>${mem.member_name}</td>
								<td>${mem.date_opened}</td>
								<td>${mem.valid_until}</td>
								<td>${mem.age_group}</td>
								<td>${mem.record_type}</td>
							`;
						body.appendChild(row);
					});
					html_table.appendChild(body);
					member_list.appendChild(html_table);

					// Show success
					success_container.appendChild(member_meta);
					success_container.appendChild(member_list);
					success_container.classList.add('active');
				}
			});
		}
		
	};

	$dt.blocks['membership-status'] = controller;

	// Set form success
	$dt.autostart.push(() => {
		$dt.OnDevelformsReady($df => {
			$df.RegisterFormPreparedEvent('membershipstatus', form => {
				form.success = resp => {
					// Transitions form using default simple methods
					form.simpleSuccess(resp);

					// Find container in instances
					const instance = controller.instances.find(c => form.currentContainer === c.form_elem);
					if (instance) {
						instance.on_success(resp);
					}
				};

				// Remove disabled attribute from button
				controller.instances.forEach(block => {
					const button = block.form_elem.querySelector('button[disabled]');
					if (button) {
						button.removeAttribute('disabled');
					}
				});
			});
		});
	});
	
})(window.d3_wp_themejs);
